// extracted by mini-css-extract-plugin
export default {"vertical-icon":"ContactCard_vertical-icon__z-Pen"};